import React from 'react';
import { Modal, Button } from 'antd';

/**
 * Modal for license upgrade (catalog slots)
 * @param {boolean} visible
 * @param {function} onClose
 * @param {object} license
 */
const LicenseUpgradeModal = ({ visible, onClose, license }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      title={`Upgrade "${license?.name || ''}" Subscription`}
      footer={null}
      centered
    >
      <p>
        You have reached the maximum number of catalogs for this license ({license?.catalogsLimit}).<br />
        If you need more catalogs, you can purchase additional catalog slots.
      </p>
      <Button type="primary" block onClick={() => alert('Purchase flow placeholder')}>Purchase additional catalog slot</Button>
    </Modal>
  );
};

export default LicenseUpgradeModal;
